/* This file is autogenerated, see readme.md for instructions */
import RewertRightSvgIcon from '@bloomreach/banana-theme/icons/rewert-right.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const RewertRightIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <RewertRightSvgIcon />
    </Icon>
  );
});

RewertRightIcon.displayName = 'RewertRightIcon';

export default RewertRightIcon;
